import React from 'react'
import Nav from '../Nav/index'
import Footer from '../Footer/index'
import Hero from './Hero/index'
import Content from './Content/index'
import Faqs from './Faqs/index'
import { Helmet } from 'react-helmet'

function index() {
  return (
    <>
                <Helmet>
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11084448289"></script>
                    
                    <title>At-Home IV Drip: Convenience and Wellness</title>
                    <meta name="description" content="Experience ultimate convenience and wellness with our at-home IV drip services. Recharge and revitalize in the comfort of your own space. Schedule now!" data-react-helmet="true"/>
                    <link rel="canonical" href="https://www.kynohealth.com/iv-therapy"/>

            </Helmet>
    <Nav/>
    <Hero/>
    <Content/>
    <Faqs/>
    <Footer/>
    </>
  )
}

export default index